import * as React from 'react';
const WorkInProgress = () => {
   
	return (
		<>
			 <div
        className="text-center px-12 py-16 sm:py-20 lg:py-24 xl:py-32 flex items-center justify-center bg-cover bg-no-repeat bg-center"
      
      >
        <div className="max-w-md xl:max-w-lg">

          <h2 className="text-2xl md:text-2xl 2xl:text-2xl font-bold text-skin-base pt-5 xl:pt-9">
            {'This feature is currently under work in progress. It will be available shortly. We will notify once it is available'}
          </h2>
        </div>
      </div>
		</>
	);
};
export default WorkInProgress;
